import { render, staticRenderFns } from "./DevelopView.vue?vue&type=template&id=2cbb5f5b&scoped=true"
import script from "./DevelopView.vue?vue&type=script&lang=js"
export * from "./DevelopView.vue?vue&type=script&lang=js"
import style0 from "./DevelopView.vue?vue&type=style&index=0&id=2cbb5f5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb5f5b",
  null
  
)

export default component.exports